(function(){
  document.addEventListener('click',function(event){
    const detailsToClose=[...document.querySelectorAll('details[data-auto-close-details][open]')].filter(function(element){
      const closingOn=window.innerWidth<750?'mobile':'desktop';
      return element.getAttribute('data-auto-close-details')?.includes(closingOn)&&!(event.target instanceof Node&&element.contains(event.target));
    });
    for(const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });

  function initCustomHeaderMenus(){
    document.querySelectorAll('.ch-mobile').forEach(function(root){
      if(root.dataset.menuFixReady==='true') return;
      root.dataset.menuFixReady='true';
      const details=root.querySelector('details');
      const summary=root.querySelector('summary');
      const panel=root.querySelector('.ch-mobile-panel');
      if(!details||!summary||!panel) return;

      panel.classList.add('ch-mobile-drawer');
      summary.setAttribute('role','button');
      summary.setAttribute('aria-expanded','false');
      summary.addEventListener('click',function(e){
        e.preventDefault();
        const open=!details.hasAttribute('open');
        if(open){details.setAttribute('open','');document.documentElement.classList.add('ch-menu-open');}
        else{details.removeAttribute('open');document.documentElement.classList.remove('ch-menu-open');}
        summary.setAttribute('aria-expanded',String(open));
      });

      if(!panel.querySelector('.ch-mobile-drawer-inner')){
        const old=[...panel.children];
        const inner=document.createElement('div'); inner.className='ch-mobile-drawer-inner';
        const close=document.createElement('button'); close.type='button'; close.className='ch-mobile-close'; close.setAttribute('aria-label','Close menu'); close.innerHTML='×';
        close.addEventListener('click',function(){details.removeAttribute('open');summary.setAttribute('aria-expanded','false');document.documentElement.classList.remove('ch-menu-open');});
        inner.appendChild(close);
        old.forEach(function(el){
          if(el.tagName==='A'){
            const row=document.createElement('div'); row.className='ch-mobile-row';
            row.appendChild(el); inner.appendChild(row);
          }
        });
        panel.innerHTML=''; panel.appendChild(inner);
      }

      function closeOnEscape(e){if(e.key==='Escape'&&details.hasAttribute('open')){details.removeAttribute('open');summary.setAttribute('aria-expanded','false');document.documentElement.classList.remove('ch-menu-open');}}
      document.addEventListener('keydown',closeOnEscape);
    });

    if(!document.querySelector('#ch-menu-fix-style')){
      const style=document.createElement('style'); style.id='ch-menu-fix-style';
      style.textContent=`
        @media(max-width:749px){
          html.ch-menu-open,html.ch-menu-open body{overflow:hidden!important}
          .ch-mobile{position:relative;z-index:10001}
          .ch-mobile details{position:static!important}
          .ch-mobile summary{position:relative;z-index:10003;display:flex;align-items:center;justify-content:center;width:40px;height:40px}
          .ch-mobile-panel.ch-mobile-drawer{position:fixed!important;left:0!important;right:auto!important;top:0!important;width:min(88vw,360px)!important;height:100dvh!important;max-height:100dvh!important;margin:0!important;padding:0!important;background:#fff!important;color:#000!important;border:0!important;border-right:1px solid #ADADAD!important;box-shadow:12px 0 40px rgba(0,0,0,.22)!important;z-index:10002!important;overflow-y:auto!important;transform:translateX(-105%);transition:transform .28s ease!important}
          .ch-mobile details[open] .ch-mobile-panel.ch-mobile-drawer{transform:translateX(0)!important}
          .ch-mobile-drawer-inner{min-height:100%;padding:18px 20px 30px;background:#fff}
          .ch-mobile-close{display:flex;align-items:center;justify-content:center;margin-left:auto;margin-bottom:12px;width:40px;height:40px;border:1px solid #ADADAD;background:#000;color:#fff;font-size:28px;line-height:1;border-radius:4px;cursor:pointer}
          .ch-mobile-row{border-bottom:1px solid #ADADAD}
          .ch-mobile-row a{display:flex!important;align-items:center;min-height:52px;padding:12px 4px!important;color:#000!important;background:#fff!important;border:0!important;font-size:15px;font-weight:600}
          .ch-mobile-panel.ch-mobile-drawer:before{content:'MENU';display:block;font-size:12px;letter-spacing:.14em;font-weight:800;color:#ADADAD;padding:4px 4px 14px;border-bottom:1px solid #ADADAD;margin-bottom:4px}
          .ch-mobile-panel.ch-mobile-drawer .ch-mobile-drawer-inner:after{content:'';position:fixed;inset:0 auto 0 0;width:min(88vw,360px);z-index:-1;background:#fff}
        }
        @media(min-width:750px){
          .ch-desktop-nav .ch-nav-inner{overflow:visible!important}
          .ch-desktop-nav .ch-nav-item{position:relative}
          .ch-desktop-nav .ch-nav-item>a{display:flex;align-items:center;gap:6px}
          .ch-desktop-nav .ch-nav-submenu{position:absolute;left:0;top:100%;min-width:220px;background:#fff;border:1px solid #ADADAD;box-shadow:0 12px 30px rgba(0,0,0,.14);padding:8px 0;margin:0;list-style:none;display:none;z-index:10000}
          .ch-desktop-nav .ch-nav-item:hover>.ch-nav-submenu,.ch-desktop-nav .ch-nav-item:focus-within>.ch-nav-submenu{display:block}
          .ch-desktop-nav .ch-nav-submenu a{display:flex!important;padding:11px 16px!important;color:#000!important;background:#fff!important;white-space:nowrap;border:0!important}
          .ch-desktop-nav .ch-nav-submenu a:hover{background:#ADADAD!important;color:#000!important}
          .ch-desktop-nav .ch-nav-item.has-submenu>a:after{content:'⌄';position:static!important;margin-left:2px;background:none!important}
          .ch-desktop-nav .ch-nav-submenu .ch-nav-submenu{left:100%;top:-9px}
        }
      `;
      document.head.appendChild(style);
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initCustomHeaderMenus); else initCustomHeaderMenus();
})();